import { getUpgradePackagesPilot } from '@/services/remoteUpgrade';

export default {
  namespace: 'RemoteUpgrade_pilotPackages',

  state: {
    data: {},
  },

  effects: {
    *fetch({ payload }, { call, put }) {
      const { status, data } = yield call(getUpgradePackagesPilot, payload);

      if (status === 200) {
        yield put({
          type: 'save',
          payload: {
            list: data.data,
            pagination: {
              total: data.meta.total,
              pageSize: data.meta.per_page,
              current: data.meta.current_page,
            },
          },
        });
      }
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        data: payload,
      };
    },
  },
};
